import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  RoleResponse,
  Role,
  AddRoleResponse,
  RoleCommonResponse,
} from '@core/interface/roles';
import { environment } from '@environment/environment';

@Injectable({
  providedIn: 'root',
})
export class RoleService {
  constructor(private http: HttpClient) {}

  getRoles() {
    return this.http.get<RoleResponse>(environment.endPoints.roleList);
  }

  addRole(data: Role) {
    return this.http.post<AddRoleResponse>(
      environment.endPoints.roleAddEdit,
      data
    );
  }
  deleteRole(id: number) {
    return this.http.get<RoleCommonResponse>(
      environment.endPoints.roleDelete(id)
    );
  }
}
